// src/plugins/index.ts
import { App } from 'vue'
import { DEPENDENCIES_TOKEN, DependenciesProvider } from '@/core/shared/domain/dependencies.ts'
import { GetWorkshopsUseCase } from '@/core/workshop/application/GetWorkshopsUseCase.ts'
import { WorkshopRepositoryBackendClient } from '@/core/workshop/infra/WorkshopRepositoryBackendClient.ts'
import { BrandRepositoryBackendClient } from '@/core/brand/infra/BrandRepositoryBackendClient.ts'
import { GetBrandsUseCase } from '@/core/brand/application/GetBrandsUseCase.ts'
import { VehicleRepositoryBackendClient } from '@/core/vehicle/infra/VehicleRepositoryBackendClient.ts'
import { GetVehicleByPlateUseCase } from '@/core/vehicle/application/GetVehicleByPlateUseCase.ts'
import { GetServicesUseCase } from '@/core/service/application/GetServicesUseCase.ts'
import { ServiceRepositoryBackendClient } from '@/core/service/infra/ServiceRepositoryBackendClient.ts'
import { GetAvailabilityUseCase } from '@/core/availability/application/GetAvailabilityUseCase.ts'
import { AvailabilityRepositoryBackendClient } from '@/core/availability/infra/AvailabilityRepositoryBackendClient.ts'
import { CreateAppointmentUseCase } from '@/core/appointment/application/CreateAppointmentUseCase.ts'
import { AppointmentRepositoryBackendClient } from '@/core/appointment/infra/AppointmentRepositoryBackendClient.ts'
import { GetAppointmentUseCase } from '@/core/appointment/application/GetAppointmentUseCase.ts'
import { CancelAppointmentUseCase } from '@/core/appointment/application/CancelAppointmentUseCase.ts'
import { EditAppointmentUseCase } from '@/core/appointment/application/EditAppointmentUseCase.ts'
import { GetCookiesUrlUseCase } from '@/core/cookies/application/GetCookiesUrlUseCase.ts'
import { CookiesRepositoryBackendClient } from '@/core/cookies/infra/CookiesRepositoryBackendClient.ts'

type Options = {
  backendUrl: string
}

export default {
  install(app: App, options: Options) {
    const { backendUrl } = options
    const workshopBackendRepository = new WorkshopRepositoryBackendClient(backendUrl)
    const brandBackendRepository = new BrandRepositoryBackendClient(backendUrl)
    const vehicleBackendRepository = new VehicleRepositoryBackendClient(backendUrl)
    const serviceBackendRepository = new ServiceRepositoryBackendClient(backendUrl)
    const availabilityBackendRepository = new AvailabilityRepositoryBackendClient(backendUrl)
    const appointmentBackendRepository = new AppointmentRepositoryBackendClient(backendUrl)
    const cookiesBackendRepository = new CookiesRepositoryBackendClient(backendUrl)

    app.provide<DependenciesProvider>(DEPENDENCIES_TOKEN, {
      getWorkshopsUseCase: new GetWorkshopsUseCase({
        workshopRepository: workshopBackendRepository
      }),
      getBrandsUseCase: new GetBrandsUseCase({ brandRepository: brandBackendRepository }),
      getVehicleByPlateUseCase: new GetVehicleByPlateUseCase({
        vehicleRepository: vehicleBackendRepository
      }),
      getServicesUseCase: new GetServicesUseCase({
        serviceRepository: serviceBackendRepository
      }),
      getWorkshopAvailabilityUseCase: new GetAvailabilityUseCase({
        availabilityRepository: availabilityBackendRepository
      }),
      createAppointmentUseCase: new CreateAppointmentUseCase({
        appointmentRepository: appointmentBackendRepository
      }),
      getAppointmentUseCase: new GetAppointmentUseCase({
        appointmentRepository: appointmentBackendRepository
      }),
      cancelAppointmentUseCase: new CancelAppointmentUseCase({
        appointmentRepository: appointmentBackendRepository
      }),
      editAppointmentUseCase: new EditAppointmentUseCase({
        appointmentRepository: appointmentBackendRepository
      }),
      getCookiesUrlUseCase: new GetCookiesUrlUseCase({
        cookiesRepository: cookiesBackendRepository
      })
    })
  }
}
